<div class="screen-element help-screen">
  <svg>
    <path viewBox="0 0 320 240" fill="none" stroke="white" stroke-width="1" id="border" d="M5 5 L340 5 L340 225 L50 225 L5 240 L25 225 L5 225 Z" />
    Sorry, your browser does not support inline SVG.
  </svg>
  <div class="content-wrap">
    @if (maxScrollIterations() > 0) {
      <div class="scrollbar-wrap">
        <div class="scrollbar" [ngStyle]="{'height':scrollbarHeight,'top':scrollbarTop}">&nbsp;</div>
      </div>
    }
    <div class="content" [ngStyle]="{'top':top}">

      <div class="icon-wrap">
        <span class="icon inline-icon {{icon}}">&nbsp;</span>
      </div>
      <div>
        @if (text != undefined) {
          <div #helpText class="text">
            <text-widget [color]="'white'" [text]="text"></text-widget>
          </div>
        }

      </div>
    </div>

  </div>